import { TableHeadCell } from '@client/toolkit';
import { MdOutlineSwapVert, MdOutlineArrowUpward, MdOutlineArrowDownward } from 'react-icons/md';
import classNames from 'classnames';
export function SortableTableHeadCell({
  label,
  id,
  handleSort,
  sortColumn,
  sortDirection,
  className,
}: {
  label: string;
  id: string;
  handleSort: (col: string) => void;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc';
  className?: string;
}) {
  return (
    <TableHeadCell
      className={classNames('px-2 py-3 cursor-pointer select-none', className)}
      size="medium"
      tabIndex={0}
      aria-label={`Sorter etter ${label}`}
      onClick={() => handleSort(id)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleSort(id);
      }}
    >
      <span className="flex items-center gap-1">
        <span dangerouslySetInnerHTML={{ __html: label }} />
        {sortColumn === id ? (
          sortDirection === 'asc' ? (
            <MdOutlineArrowUpward />
          ) : (
            <MdOutlineArrowDownward />
          )
        ) : (
          <MdOutlineSwapVert />
        )}
      </span>
    </TableHeadCell>
  );
}
